import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../../utils/Utils";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Input from "../../../../../../../components/textbox/Input";
import $ from "jquery";
import Select from "../../../../../../../components/select/Select";

class OrigineDelContagio extends Component {

    state = {
        origineDelContagio: {

            effettuatoViaggi: "",
            dove: "",
            regione: "",
            nazione: "",
            dataPartenza: "",
            dataRientro: "",

            appartenenzaFocolaio: "",
            eventualeFocolaio: "",

            contattoConAltroCaso: "",
            datiContatto: "",
            importato: "",
            eventualeNazione: "",

            comunitaContatto: "",
            eventualeAltraComunita: "",
            localitaContatto: "",
            regioneContatto: "",
            nazioneContatto: "",
            corretto: []

        },
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        regioni: OggettiUtili.Regioni
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.disabledCalendar = this.disabledCalendar.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.validate = this.validate.bind(this);
        this.disablePicker = this.disablePicker.bind(this)
    }

    componentDidMount() {
        let origineDelContagio = this.state.origineDelContagio
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.origineDelContagio) {
            let origineDelContagioCopia = this.props.segnalazioneCopia.schedaSpeciale.origineDelContagio
            for (let key in origineDelContagio) {
                if (origineDelContagio.hasOwnProperty(key) === origineDelContagioCopia.hasOwnProperty(key)) {
                    if (key === "regione" || key === "regioneContatto") {
                        if (origineDelContagioCopia[key] && origineDelContagioCopia[key].length === 2) {
                            origineDelContagioCopia[key] = origineDelContagioCopia[key].concat("0")
                        }
                        origineDelContagio[key] = this.state.regioni[origineDelContagioCopia[key]] ? this.state.regioni[origineDelContagioCopia[key]] : ""
                    } else if (key === "nazione" || key === "eventualeNazione" || key === "nazioneContatto") {
                        origineDelContagio[key] = this.state.nazioniPerCodice[origineDelContagioCopia[key]] ? this.state.nazioniPerCodice[origineDelContagioCopia[key]] : ""
                    } else {
                        origineDelContagio[key] = origineDelContagioCopia[key]
                    }
                } else {
                    origineDelContagio[key] = ""
                }
            }
            this.setState({origineDelContagio: origineDelContagio})
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("origineDelContagio", oggettoBE, corretto)
            this.disabledCalendar()
            this.disablePicker()

        } else {
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("origineDelContagio", oggettoBE, corretto)
            this.disabledCalendar()
            this.disablePicker()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledCalendar()
        this.disablePicker()
    }

    disablePicker() {
        if (this.state.origineDelContagio.contattoConAltroCaso !== "1" && this.state.origineDelContagio.contattoConAltroCaso !== "2") {
            $(document).ready(function () {
                $('.selectpicker').selectpicker('disabled', true)
                $('.selectpicker').selectpicker('refresh')
            });
        } else {
            $(document).ready(function () {
                $('.selectpicker').selectpicker('enable')
                $('.selectpicker').selectpicker('refresh')
            });
        }
    }

    validate() {

        if (this.state.origineDelContagio.dataPartenza && Utils.validateDate(this.state.origineDelContagio.dataPartenza, "Messages.DataOrigini", "Messages.DataOriginiOdierna")) {
            return Utils.validateDate(this.state.origineDelContagio.dataPartenza, "Messages.DataOrigini", "Messages.DataOriginiOdierna")
        }
        if (this.state.origineDelContagio.dataRientro && Utils.validateDate(this.state.origineDelContagio.dataRientro, "Messages.DataOrigini", "Messages.DataOriginiOdierna")) {
            return Utils.validateDate(this.state.origineDelContagio.dataRientro, "Messages.DataOrigini", "Messages.DataOriginiOdierna")
        }

        if (Utils.checkDateInterval(this.state.origineDelContagio.dataRientro, this.state.origineDelContagio.dataPartenza)) {
            return "Messages.ERR_01_01_0F_0N"
        }

        return ""

    }

    riceviValore(field, event) {
        let origineDelContagio = this.state.origineDelContagio
        origineDelContagio[field] = event.target.value
        if (origineDelContagio.effettuatoViaggi !== "1") {
            origineDelContagio.dove = ""
            origineDelContagio.nazione = ""
            origineDelContagio.regione = ""
            origineDelContagio.dataPartenza = ""
            origineDelContagio.dataRientro = ""
        }
        if (origineDelContagio.dove !== "1") {
            origineDelContagio.regione = ""
        }
        if (origineDelContagio.comunitaContatto !== "3") {
            origineDelContagio.eventualeAltraComunita = ""
        }
        if (origineDelContagio.dove !== "2") {
            origineDelContagio.nazione = ""
        }
        if (origineDelContagio.appartenenzaFocolaio !== "1") {
            origineDelContagio.eventualeFocolaio = ""
        }
        if (origineDelContagio.contattoConAltroCaso !== "1" && origineDelContagio.contattoConAltroCaso !== "2") {
            origineDelContagio.datiContatto = ""
            origineDelContagio.importato = ""
            origineDelContagio.eventualeNazione = ""
            origineDelContagio.comunitaContatto = ""
            origineDelContagio.localitaContatto = ""
            origineDelContagio.regioneContatto = ""
            origineDelContagio.nazioneContatto = ""
        }
        if (origineDelContagio.localitaContatto !== "2") {
            origineDelContagio.regioneContatto = ""
        }
        if (origineDelContagio.localitaContatto !== "3") {
            origineDelContagio.nazioneContatto = ""
        }
        if (origineDelContagio.importato !== "1") {
            origineDelContagio.eventualeNazione = ""
        }
        this.setState({origineDelContagio: origineDelContagio})
        let corretto = this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        this.props.createOggettoBeAndcontrolloCorrettezza("origineDelContagio", oggettoBE, corretto, this.validate())
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.origineDelContagio))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        oggettoBE.regione = oggettoBE.regione.codice ? oggettoBE.regione.codice : ""
        oggettoBE.nazione = oggettoBE.nazione.codice ? oggettoBE.nazione.codice : ""
        oggettoBE.eventualeNazione = oggettoBE.eventualeNazione.codice ? oggettoBE.eventualeNazione.codice : ""
        oggettoBE.regioneContatto = oggettoBE.regioneContatto.codice ? oggettoBE.regioneContatto.codice : ""
        oggettoBE.nazioneContatto = oggettoBE.nazioneContatto.codice ? oggettoBE.nazioneContatto.codice : ""
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    disabledCalendar() {
        if (this.state.origineDelContagio.effettuatoViaggi !== "1") {
            document.getElementById("doveItalia").disabled = true;
            document.getElementById("doveEstero").disabled = true;
            $(document).ready(function () {
                $("#dataPartenza").datepicker('disable');
                $("#dataRientro").datepicker('disable');
            })
        } else {
            document.getElementById("doveItalia").disabled = false;
            document.getElementById("doveEstero").disabled = false;
            $(document).ready(function () {
                $("#dataPartenza").datepicker('enable');
                $("#dataRientro").datepicker('enable');
            })
        }
    }

    controlloCorrettezza() {
        let origineDelContagio = this.state.origineDelContagio
        origineDelContagio.corretto = []

        if (!origineDelContagio.effettuatoViaggi) origineDelContagio.corretto[0] = "Campo \"Il caso ha effettuato viaggi nei 7/23 giorni precedenti l'inizio dell'esantema\" mancante";
        if (!origineDelContagio.contattoConAltroCaso) origineDelContagio.corretto[1] = "Campo \"Il paziente è stato a contatto con un altro caso confermato di morbillo (entro 7/18 giorni) o di rosolia (entro 12/23 giorni) prima dell'esordio dell'esantema\" mancante";
        if (origineDelContagio.comunitaContatto === "3" && !origineDelContagio.eventualeAltraComunita) origineDelContagio.corretto[2] = "Campo \"In quale comunità è avvenuto il contatto - Comunità\" mancante";

        if (origineDelContagio.effettuatoViaggi === "1") {
            if (!origineDelContagio.dove) origineDelContagio.corretto[3] = "Campo \"Se si, Dove\" mancante";
            if (!origineDelContagio.dataPartenza || (origineDelContagio.dataPartenza && Utils.isDateInValid(Utils.transformDateForBackend(origineDelContagio.dataPartenza), "-"))) origineDelContagio.corretto[4] = "Campo \"Se si, Quando - Da\" mancante o errato";
            if (!origineDelContagio.dataRientro || (origineDelContagio.dataRientro && Utils.isDateInValid(Utils.transformDateForBackend(origineDelContagio.dataRientro), "-"))) origineDelContagio.corretto[5] = "Campo \"Se si, Quando - A\" mancante o errato";
            if (origineDelContagio.dove === "1" && !origineDelContagio.regione) origineDelContagio.corretto[6] = "Campo \"Italia, specificare Regione\" mancante";
            if (origineDelContagio.dove === "2" && !origineDelContagio.nazione) origineDelContagio.corretto[7] = "Campo \"Italia, specificare Nazione\" mancante";
        }

        if (!origineDelContagio.appartenenzaFocolaio) origineDelContagio.corretto[8] = "Campo \"Il caso fa parte di un focolaio\" mancante";
        if (origineDelContagio.appartenenzaFocolaio === "1" && !origineDelContagio.eventualeFocolaio) origineDelContagio.corretto[9] = "Campo \"Si, indicare focolaio\" mancante";

        if (origineDelContagio.contattoConAltroCaso === "1" || origineDelContagio.contattoConAltroCaso === "2") {
            if (!origineDelContagio.datiContatto) origineDelContagio.corretto[10] = "Campo \"Se si, indicare il cognome e nome del contatto\" mancante";
            if (!origineDelContagio.importato) origineDelContagio.corretto[11] = "Campo \"Il contatto è un caso importato?\" mancante";
            if (!origineDelContagio.importato && !origineDelContagio.eventualeNazione) origineDelContagio.corretto[12] = "Campo \"Se si, da quale nazione?\" mancante";
            if (!origineDelContagio.comunitaContatto) origineDelContagio.corretto[13] = "Campo \"In quale comunità è avvenuto il contatto\" mancante";
            if (!origineDelContagio.localitaContatto) origineDelContagio.corretto[14] = "Campo \"In quale località è avvenuto il contatto\" mancante";
            if (origineDelContagio.localitaContatto === "2" && !origineDelContagio.regioneContatto) origineDelContagio.corretto[15] = "Campo \"In quale località è avvenuto il contatto - In altra regione.Dove\" mancante";
            if (origineDelContagio.localitaContatto === "3" && !origineDelContagio.nazioneContatto) origineDelContagio.corretto[16] = "Campo \"In quale località è avvenuto il contatto - All'estero. Dove\" mancante";
        }

        return origineDelContagio.corretto

    }

    render() {

        const {t} = this.props

        const viaggi = (
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.effettuatoViaggi")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"effettuatoViaggiSi"} name={"effettuatoViaggi"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"1"}
                                             checked={this.state.origineDelContagio.effettuatoViaggi === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-5"}>
                                <RadioButton id={"effettuatoViaggiNo"} name={"effettuatoViaggi"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.origineDelContagio.effettuatoViaggi === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-2"}>
                        <p style={{color: "black", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.seSi")}
                            <span style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.dove")}</span>
                            {this.state.origineDelContagio.effettuatoViaggi === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-10"}>
                        <div className={"row"}>
                            <div className={"col-lg-4"}>
                                <RadioButton id={"doveItalia"} name={"dove"}
                                             label={t("SchedaSpecialeMorbillo.italia")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"1"}
                                             checked={this.state.origineDelContagio.dove === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-5"}>
                                <div className={styles.fieldContainer}>
                                    <Autocomplete
                                        id={"regione"}
                                        onChange={this.riceviValore}
                                        field={"regione"}
                                        keyField={"codice"}
                                        required={this.state.origineDelContagio.dove === "1"}
                                        descriptionField={"descrizione"}
                                        suggestionField={"descrizione"}
                                        value={this.state.origineDelContagio.regione}
                                        disabled={this.state.origineDelContagio.dove !== "1" ? true : false}
                                        suggestions={this.state.regioni}
                                        placeholder={t("SchedaSpecialeMorbillo.regione")}
                                    >
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-lg-4"}>
                                <RadioButton id={"doveEstero"} name={"dove"}
                                             label={t("SchedaSpecialeMorbillo.estero")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"2"}
                                             checked={this.state.origineDelContagio.dove === "2"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-5"}>
                                <div className={styles.fieldContainer}>

                                    <Autocomplete id={"nazione"}
                                                  value={this.state.origineDelContagio.nazione}
                                                  keyField={"codice"}
                                                  required={this.state.origineDelContagio.dove === "2"}
                                                  descriptionField={"descrizione"}
                                                  suggestionField={"descrizione"}
                                                  onChange={this.riceviValore}
                                                  disabled={this.state.origineDelContagio.dove !== "2" ? true : false}
                                                  field={"nazione"}
                                                  placeholder={t("SchedaSpecialeMorbillo.nazione")}
                                                  suggestions={this.state.nazioni}
                                    >
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-2"}>
                        <p style={{color: "black", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.seSi")}
                            <span style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.quando")}</span>
                            {this.state.origineDelContagio.effettuatoViaggi === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-8"}>
                        <div className={"row"}>
                            <div className={"col-lg-1"}>
                                <p style={{color: "black", marginTop: "0.5rem"}}>
                                    {t("SchedaSpecialeMorbillo.da")}
                                </p>
                            </div>
                            <div className={"col-lg-5"}>
                                <Calendar
                                    id={"dataPartenza"}
                                    value={this.state.origineDelContagio.dataPartenza}
                                    field={"dataPartenza"}
                                    newCalendar={true}
                                    onChange={this.riceviValore}
                                    disabled={this.state.origineDelContagio.effettuatoViaggi !== "1" ? true : false}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.da"))}
                                    error={(this.state.origineDelContagio.dataPartenza === "" || this.state.origineDelContagio.dataPartenza == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.origineDelContagio.dataPartenza), "-")
                                    }
                                >
                                </Calendar>
                            </div>
                        </div>
                        <div className={"row"} style={{marginTop: "1rem"}}>
                            <div className={"col-lg-1"}>
                                <p style={{color: "black", marginTop: "0.5rem"}}>
                                    {t("SchedaSpecialeMorbillo.a")}
                                </p>
                            </div>
                            <div className={"col-lg-5"}>
                                <Calendar
                                    id={"dataRientro"}
                                    value={this.state.origineDelContagio.dataRientro}
                                    field={"dataRientro"}
                                    newCalendar={true}
                                    onChange={this.riceviValore}
                                    disabled={this.state.origineDelContagio.effettuatoViaggi !== "1" ? true : false}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.a"))}
                                    error={(this.state.origineDelContagio.dataRientro === "" || this.state.origineDelContagio.dataRientro == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.origineDelContagio.dataRientro), "-")
                                    }
                                >
                                </Calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )


        const focolaio = (
            <div style={{marginTop: "1rem"}} className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-4"}>
                        <p style={{fontWeight: "bold", color: "black", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.parteFocolaio")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-8"}>
                        <div className={"row"}>
                            <div className={"col-lg-10"}>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <RadioButton id={"appartenenzaSi"} name={"appartenenzaFocolaio"}
                                                     label={t("SchedaSpecialeMorbillo.indicareFocolaio")}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     newRadio={true}
                                                     onClick={this.riceviValore}
                                                     smallLabel={true}
                                                     value={"1"}
                                                     checked={this.state.origineDelContagio.appartenenzaFocolaio === "1"}>
                                        </RadioButton>
                                    </div>
                                    <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                        <Input id={"eventualeFocolaio"}
                                               onChange={this.riceviValore}
                                               field={"eventualeFocolaio"}
                                               required={this.state.origineDelContagio.appartenenzaFocolaio === "1"}
                                               disabled={this.state.origineDelContagio.appartenenzaFocolaio !== "1" ? true : false}
                                               value={this.state.origineDelContagio.eventualeFocolaio}
                                               placeholder={t("SchedaSpecialeMorbillo.focolaio")}

                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"appartenenzaNo"} name={"appartenenzaFocolaio"}
                                                     label={t("SchedaSpecialeMorbillo.no")}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     newRadio={true}
                                                     onClick={this.riceviValore}
                                                     smallLabel={true}
                                                     value={"2"}
                                                     checked={this.state.origineDelContagio.appartenenzaFocolaio === "2"}>
                                        </RadioButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )

        const contatto = (
            <div className={"container"}>
                <div className={"row"}>
                    <p style={{fontWeight: "bold", color: "black", marginTop: "0.5rem"}}>
                        {t("SchedaSpecialeMorbillo.pazienteAContatto")}
                        <span className={styles.mandatoryColor}>*</span>
                    </p>
                    <div className={"row"}>
                        <RadioButton id={"contattoConAltroCasoMorbillo"} name={"contattoConAltroCaso"}
                                     label={t("SchedaSpecialeMorbillo.siMorbillo")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     smallLabel={true}
                                     value={"1"}
                                     checked={this.state.origineDelContagio.contattoConAltroCaso === "1"}>
                        </RadioButton>
                        <RadioButton id={"contattoConAltroCasoRosolia"} name={"contattoConAltroCaso"}
                                     label={t("SchedaSpecialeMorbillo.siRosolia")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     smallLabel={true}
                                     value={"2"}
                                     checked={this.state.origineDelContagio.contattoConAltroCaso === "2"}>
                        </RadioButton>
                        <RadioButton id={"contattoConAltroCasoNo"} name={"contattoConAltroCaso"}
                                     label={t("SchedaSpecialeMorbillo.no")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     smallLabel={true}
                                     value={"3"}
                                     checked={this.state.origineDelContagio.contattoConAltroCaso === "3"}>
                        </RadioButton>
                    </div>
                </div>

                <fieldset
                    disabled={this.state.origineDelContagio.contattoConAltroCaso === "1" || this.state.origineDelContagio.contattoConAltroCaso === "2" ? false : true}>
                    <div className={"row"}>
                        <div className={"col-lg-5"}>
                            <p style={{color: "black", marginTop: "0.5rem"}}>
                                {t("SchedaSpecialeMorbillo.seSi")}
                                <span style={{fontWeight: "bold", color: "black", marginTop: "0.5rem"}}>
                                {t("SchedaSpecialeMorbillo.indicareNomeCognome")}
                            </span>
                                {this.state.origineDelContagio.contattoConAltroCaso === "1" ||
                                this.state.origineDelContagio.contattoConAltroCaso === "2" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className={"col-lg-3"}>
                            <Input id={"datiContatto"}
                                   onChange={this.riceviValore}
                                   field={"datiContatto"}
                                   value={this.state.origineDelContagio.datiContatto}
                                   placeholder={t("SchedaSpecialeMorbillo.cognome") + " " + t("SchedaSpecialeMorbillo.nome")}

                            ></Input>
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-lg-5"}>
                            <p style={{fontWeight: "bold", color: "black", marginTop: "0.5rem"}}>
                                {t("SchedaSpecialeMorbillo.casoImportato")}
                                {this.state.origineDelContagio.contattoConAltroCaso === "1" ||
                                this.state.origineDelContagio.contattoConAltroCaso === "2" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <fieldset className={"col-lg-3"}>
                            <div className={"row"}>
                                <RadioButton id={"importatoSi"} name={"importato"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"1"}
                                             checked={this.state.origineDelContagio.importato === "1"}>
                                </RadioButton>
                                <RadioButton id={"importatoNo"} name={"importato"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"2"}
                                             checked={this.state.origineDelContagio.importato === "2"}>
                                </RadioButton>
                            </div>
                        </fieldset>
                    </div>

                    <div className={"row"}>
                        <div className={"col-lg-5"}>
                            <p style={{color: "black", marginTop: "0.5rem"}}>
                                {t("SchedaSpecialeMorbillo.seSi")}
                                <span style={{fontWeight: "bold", color: "black", marginTop: "0.5rem"}}>
                                {t("SchedaSpecialeMorbillo.daNazione")}
                            </span>
                                {this.state.origineDelContagio.importato === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className={"col-lg-3"}>
                            <div className={styles.fieldContainer}>

                                <Autocomplete id={"eventualeNazione"}
                                              value={this.state.origineDelContagio.eventualeNazione}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"eventualeNazione"}
                                              disabled={this.state.origineDelContagio.importato !== "1" ? true : false}
                                              placeholder={t("SchedaSpecialeMorbillo.nazione")}
                                              suggestions={this.state.nazioni}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                    </div>

                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-5"}>
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.comunitaContatto")}
                                {this.state.origineDelContagio.contattoConAltroCaso === "1" ||
                                this.state.origineDelContagio.contattoConAltroCaso === "2" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className={"col-lg-3"}>
                            <Select
                                field={"comunitaContatto"}
                                value={this.state.origineDelContagio.comunitaContatto}
                                onChange={this.riceviValore}
                                id={"comunitaContatto"}
                                newSelect={true}
                                functionMap={Utils.mapToArray(OggettiUtili.Collettivita).map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                                disabled={this.state.origineDelContagio.contattoConAltroCaso !== "1" && this.state.origineDelContagio.contattoConAltroCaso !== "2"}
                            >
                            </Select>
                            <div style={{
                                display: this.state.origineDelContagio.comunitaContatto !== "3" ? "none" : "",
                                marginTop: "1rem"
                            }}>
                                <Input id={"eventualeAltraComunita"}
                                       onChange={this.riceviValore}
                                       required={this.state.origineDelContagio.comunitaContatto === "3"}
                                       field={"eventualeAltraComunita"}
                                       value={this.state.origineDelContagio.eventualeAltraComunita}
                                       placeholder={t("SchedaSpecialeMorbillo.comunita")}

                                />
                            </div>
                        </div>
                    </div>


                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-5"}>
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.localitaContatto")}
                                {this.state.origineDelContagio.contattoConAltroCaso === "1" ||
                                this.state.origineDelContagio.contattoConAltroCaso === "2" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className={"col-lg-7"}>
                            <RadioButton id={"localitaContattoRegioneResidenza"} name={"localitaContatto"}
                                         label={t("SchedaSpecialeMorbillo.nellaRegione")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true}
                                         value={"1"}
                                         checked={this.state.origineDelContagio.localitaContatto === "1"}>
                            </RadioButton>
                            <div className={"row"}>
                                <div className={"col-lg-4"}>
                                    <RadioButton id={"localitaContattoAltraRegione"} name={"localitaContatto"}
                                                 label={t("SchedaSpecialeMorbillo.altraRegione") + t("SchedaSpecialeMorbillo.dove")}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 newRadio={true}
                                                 onClick={this.riceviValore}
                                                 smallLabel={true}
                                                 value={"2"}
                                                 checked={this.state.origineDelContagio.localitaContatto === "2"}>
                                    </RadioButton>
                                </div>
                                <div className={"col-lg-5"}>
                                    <div className={styles.fieldContainer}>

                                        <Autocomplete
                                            id={"regioneContatto"}
                                            onChange={this.riceviValore}
                                            required={this.state.origineDelContagio.localitaContatto === "2"}
                                            field={"regioneContatto"}
                                            keyField={"codice"}
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            value={this.state.origineDelContagio.regioneContatto}
                                            suggestions={this.state.regioni}
                                            disabled={this.state.origineDelContagio.localitaContatto === "2" ? false : true}
                                            placeholder={t("SchedaSpecialeMorbillo.regione")}
                                        >
                                        </Autocomplete>
                                    </div>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-lg-4"}>
                                    <RadioButton id={"localitaContattoEstero"} name={"localitaContatto"}
                                                 label={t("SchedaSpecialeMorbillo.allEstero") + t("SchedaSpecialeMorbillo.dove")}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 newRadio={true}
                                                 onClick={this.riceviValore}
                                                 smallLabel={true}
                                                 value={"3"}
                                                 checked={this.state.origineDelContagio.localitaContatto === "3"}>
                                    </RadioButton>
                                </div>
                                <div className={"col-lg-5"}>
                                    <div className={styles.fieldContainer}>

                                        <Autocomplete id={"nazioneContatto"}
                                                      value={this.state.origineDelContagio.nazioneContatto}
                                                      keyField={"codice"}
                                                      descriptionField={"descrizione"}
                                                      required={this.state.origineDelContagio.localitaContatto === "3"}
                                                      suggestionField={"descrizione"}
                                                      onChange={this.riceviValore}
                                                      disabled={this.state.origineDelContagio.localitaContatto === "3" ? false : true}
                                                      field={"nazioneContatto"}
                                                      placeholder={t("SchedaSpecialeMorbillo.nazione")}
                                                      suggestions={this.state.nazioni}
                                        >
                                        </Autocomplete>
                                    </div>
                                </div>
                            </div>


                            <RadioButton id={"localitaContattoNonSo"} name={"localitaContatto"}
                                         label={t("SchedaSpecialeMorbillo.nonSo")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true}
                                         value={"4"}
                                         checked={this.state.origineDelContagio.localitaContatto === "4"}>
                            </RadioButton>

                        </div>
                    </div>

                </fieldset>


            </div>
        )

        return (
            <div style={{marginTop: "2rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.origineDelContagio")}</h6>
                <hr className={styles.hr}/>
                {viaggi}
                {focolaio}
                {contatto}
            </div>
        );
    }

}

export default withTranslation('common')(OrigineDelContagio)
